import { rateLimitActions } from '../rateLimit'
import { describeTable } from './describeTable'

describeTable(rateLimitActions, {
  description:
    'Technical rate-limiting ledger: one row per counted attempt of an action (OTP requests, form submits, external API element counts) per identifier (e-mail, phone or IP). No business meaning; never query it for analysis.',
})
